// Main container styles
export const mainContainer = {
  backgroundColor: '#FFFFFF',
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
};

export const SnackBarComponent = {
  position: 'fixed',
  left: '32%',
  bottom: 0,
  zIndex: 99,
};

// Header styles
export const headerContainer = {
  display: 'flex',
  alignItems: 'center',
  padding: '16px 20px',
  borderBottom: '1px solid #E5E7EB',
  backgroundColor: 'white',
};

export const closeButton = {
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '32px',
  height: '32px',
  borderRadius: '50%',
  border: '1px solid #0F48B8',
  '&:hover': {
    backgroundColor: '#F3F4F6',
  },
};

export const headerTitle = {
  color: 'var(--Navy---navy-main, #061E44)',
  leadingTrim: 'both',
  textEdge: 'cap',
  fontFamily: 'Inter',
  fontSize: '32px',
  fontStyle: 'normal',
  fontWeight: 800,
  lineHeight: 'normal',
};

export const headerTextContainer = {
  display: 'flex',
  flexDirection: 'column',
  marginLeft: '12px',
};

// Content area styles
export const contentContainer = {
  flex: 1,
  padding: '24px 20px 40px 20px',
  backgroundColor: 'white',
  overflowY: 'visible',
};

// Members section styles
export const membersSection = {
  marginBottom: '24px',
};

// Autocomplete styles
export const searchIcon = {
  color: '#0096CA',
  width: '18px',
  height: '18px',
  paddingBottom: '6px',
};

export const autocompleteSx = {
  '& .MuiOutlinedInput-root': {
    width: '100%',
    maxWidth: '600px',
    borderRadius: '50px',
    paddingLeft: '16px',
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: '#0096CA',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#0096CA',
      borderWidth: '2px',
    },
  },
  '& .MuiInputAdornment-root': {
    marginRight: '8px',
  },
  '& .MuiOutlinedInput-root .MuiAutocomplete-input': {
    padding: '0px 4px 7.5px 0px !important',
  },
  '& .MuiAutocomplete-endAdornment': {
    display: 'none',
  },
  '& .MuiInputBase-input::placeholder': {
    color: 'var(--Greyscale---grey-90, #707070)',
    fontFamily: 'Inter',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '24px',
    letterSpacing: '0.32px',
    opacity: 1,
  },
  '& .MuiChip-root': {
    backgroundColor: '#F3E8FF',
    color: '#A855F7',
    '& .MuiChip-deleteIcon': {
      color: '#A855F7',
      '&:hover': {
        color: '#7C3AED',
      },
    },
  },
  '& .MuiAutocomplete-paper': {
    borderRadius: '24px',
    background: '#FFF',
    boxShadow:
      '0 1px 2px 0 rgba(0, 0, 0, 0.30), 0 2px 6px 2px rgba(0, 0, 0, 0.15)',
    '&::-webkit-scrollbar': {
      width: '4px',
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent',
      borderRadius: '2px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#CDD4E3',
      borderRadius: '2px',
      '&:hover': {
        background: '#B8C5D6',
      },
    },
    '&::-webkit-scrollbar-thumb:active': {
      background: '#A3B6C9',
    },
    scrollbarWidth: 'thin',
    scrollbarColor: '#CDD4E3 transparent',
  },
  '& .MuiAutocomplete-listbox': {
    padding: '8px 0',
    '&::-webkit-scrollbar': {
      width: '4px',
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent',
      borderRadius: '2px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#CDD4E3',
      borderRadius: '2px',
      '&:hover': {
        background: '#B8C5D6',
      },
    },
    '&::-webkit-scrollbar-thumb:active': {
      background: '#A3B6C9',
    },
    scrollbarWidth: 'thin',
    scrollbarColor: '#CDD4E3 transparent',
    position: 'relative',
    '& .dropdown-footer': {
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      background: 'white',
      display: 'flex',
      padding: '20px 20px 12px 20px',
      justifyContent: 'space-between',
      alignItems: 'center',
      gap: '4px',
      alignSelf: 'stretch',
      height: '45px',
      zIndex: 2,
    },
    '& .dropdown-footer .footer-left': {
      color: 'var(--success-green-green-dark, #228053)',
      fontFamily: 'Inter',
      fontSize: '12px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '22px',
      letterSpacing: '0.24px',
    },
    '& .dropdown-footer .footer-right': {
      color: 'var(--primary-blue-primary-deep, #0F2C54)',
      fontFamily: 'Inter',
      fontSize: '12px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '22px',
      letterSpacing: '0.24px',
    },
  },
};

export const membersAutocompleteSx = {
  ...autocompleteSx,
  '& .MuiInputLabel-root': {
    color: 'var(--primary-blue-primary-deep, #0F2C54)',
    fontFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '22px',
    letterSpacing: '0.28px',
    transform: 'translate(14px, -9px) scale(0.75)',
    backgroundColor: 'white',
    padding: '0 4px',
    '&.Mui-focused': {
      color: 'var(--primary-blue-primary-deep, #0F2C54)',
    },
  },
};

export const autocompleteListboxSx = {
  paddingTop: '0px !important',
  paddingBottom: '0px !important',
  '& .MuiAutocomplete-option': {
    padding: '0 !important',
    minHeight: '0 !important',
    margin: '0 !important',
    boxSizing: 'border-box',
  },
};

// Footer styles
export const footerContainer = {
  display: 'flex',
  minHeight: '80px',
  padding: '0 24px',
  justifyContent: 'flex-end',
  alignItems: 'center',
  gap: '12px',
  flexShrink: 0,
  alignSelf: 'stretch',
  borderTop: '1px solid var(--Greyscale---grey-60, #CDD4E3)',
  marginTop: '120px',
};

export const createButton = {
  borderRadius: '100px',
  background: 'var(--primary-blue-primary-main, #0F48B8)',
  display: 'flex',
  minHeight: '40px',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '8px',
  color: 'white',
  fontSize: '16px',
  fontWeight: 600,
  textTransform: 'none',
  padding: '0 24px',
  boxShadow: 'none',
  '&:hover': {
    background: 'var(--primary-blue-primary-main, #0F48B8)',
    boxShadow: 'none',
  },
  '&:disabled': {
    backgroundColor: '#9CA3AF',
    boxShadow: 'none',
  },
};

/**
 * Returns button styles based on disabled state
 * @param {boolean} isDisabled - Whether the button is disabled
 * @returns {Object} - Button style object
 */
export const getCreateButtonStyles = (isDisabled) => {
  if (isDisabled) {
    return {
      ...createButton,
      backgroundColor: '#9CA3AF',
      background: '#9CA3AF',
      color: '#FFFFFF',
      cursor: 'not-allowed',
    };
  }
  
  return {
    ...createButton,
    backgroundColor: 'var(--primary-blue-primary-main, #0F48B8)',
    background: 'var(--primary-blue-primary-main, #0F48B8)',
    color: '#FFFFFF',
  };
};

export const cancelButton = {
  display: 'flex',
  height: '40px',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '8px',
  borderRadius: '100px',
  border: '1px solid var(--Navy---navy-main, #061E44)',
  backgroundColor: 'white',
  color: '#374151',
  padding: '0 24px',
  fontSize: '16px',
  fontWeight: 600,
  textTransform: 'none',
  boxShadow: 'none',
  '&:hover': {
    boxShadow: 'none',
    backgroundColor: 'white',
    border: '1px solid var(--Navy---navy-main, #061E44)',
  },
};

